import { render, staticRenderFns } from "./sitetagshealth.vue?vue&type=template&id=453a900b&scoped=true"
import script from "./sitetagshealth.vue?vue&type=script&lang=js"
export * from "./sitetagshealth.vue?vue&type=script&lang=js"
import style0 from "./sitetagshealth.vue?vue&type=style&index=0&id=453a900b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a900b",
  null
  
)

export default component.exports